// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getForms as listFormsAPI,
    getForm as getFormAPI,
    addForm as addFormAPI,
    updateForm as updateFormAPI,
    deleteForm as deleteFormAPI
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { formsApiResponseError, formsApiResponseSuccess } from './actions';
import { FormsActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getForm({ payload: { id } }) {
    try {
        const response = yield call(getFormAPI, id);
        const form = response.data.data;
        yield put(formsApiResponseSuccess(FormsActionTypes.GET_FORM, form));
    } catch (error) {
        yield put(formsApiResponseError(FormsActionTypes.GET_FORM, error));
    }
}

/**
 * List contactos
 */
function* listForms() {
    try {
        const response = yield call(listFormsAPI);
        const listaForms = response.data.data;
        yield put(formsApiResponseSuccess(FormsActionTypes.LIST_FORMS, listaForms));
    } catch (error) {
        yield put(formsApiResponseError(FormsActionTypes.LIST_FORMS, error));
    }
}

function* addForm({ payload: form }) {
    try {
        const response = yield call(addFormAPI, { ...form })
        const formItem = response.data.data
        yield put(formsApiResponseSuccess(FormsActionTypes.ADD_FORM, formItem))
    } catch (error) {
        yield put(formsApiResponseError(FormsActionTypes.ADD_FORM, error))
    }
}

function* updateForm({ payload: form }) {
    try {
        const response = yield call(updateFormAPI, { ...form })
        const formItem = response.data.data
        yield put(formsApiResponseSuccess(FormsActionTypes.UPDATE_FORM, formItem))
    } catch (error) {
        yield put(formsApiResponseError(FormsActionTypes.UPDATE_FORM, error))
    }
}

function* deleteForm({ payload: { id } }) {
    try {
        const response = yield call(deleteFormAPI, id)
        const formItem = response.data.id
        yield put(formsApiResponseSuccess(FormsActionTypes.DELETE_FORM, formItem))
    } catch (error) {
        yield put(formsApiResponseError(FormsActionTypes.DELETE_FORM, error))
    }
}


export function* watchGetForm(): any {
    yield takeEvery(FormsActionTypes.GET_FORM, getForm);
}

export function* watchListForms(): any {
    yield takeEvery(FormsActionTypes.LIST_FORMS, listForms);
}

export function* watchAddForm(): any {
    yield takeEvery(FormsActionTypes.ADD_FORM, addForm);
}

export function* watchUpdateForm(): any {
    yield takeEvery(FormsActionTypes.UPDATE_FORM, updateForm);
}
export function* watchDeleteForm(): any {
    yield takeEvery(FormsActionTypes.DELETE_FORM, deleteForm);
}


function* formsSaga(): any {
    yield all([
        fork(watchGetForm),
        fork(watchListForms),
        fork(watchAddForm),
        fork(watchUpdateForm),
        fork(watchDeleteForm),
    ]);
}

export default formsSaga;
